import Button from '~components/Button';

import Divider from '../Divider';
import Gnb from '../Gnb';
import SearchBar from '../SearchBar';
import SessionMenuForDesktop from '../SessionMenuForDesktop';
import * as S from './style';

export default function HeaderContentsForDesktop() {
  return (
    <>
      <S.SearchWrapper>
        <SearchBar />
      </S.SearchWrapper>
      <Gnb />
      <Divider marginLeft={16} marginRight={24} />
      <SessionMenuForDesktop />
      <Divider marginXAxis={24} />
      <Button
        size='sm'
        variant='light'
        data-attribute-id='gnb'
        data-gnb-kind='companyhq'
        as='a'
        href='https://www.wanted.co.kr/dashboard/welcome'
        target='_blank'>
        기업 서비스
      </Button>
    </>
  );
}
